export var DocumentProcessingStatus;
(function (DocumentProcessingStatus) {
    DocumentProcessingStatus[DocumentProcessingStatus["NotProcessed"] = 0] = "NotProcessed";
    DocumentProcessingStatus[DocumentProcessingStatus["Success"] = 1] = "Success";
    DocumentProcessingStatus[DocumentProcessingStatus["RetryableFailure"] = 2] = "RetryableFailure";
    DocumentProcessingStatus[DocumentProcessingStatus["NonRetryableFailure"] = 3] = "NonRetryableFailure";
})(DocumentProcessingStatus || (DocumentProcessingStatus = {}));
